import React, {useEffect, useState, useRef} from 'react';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import Footer from '../../components/Footer/Footer';
import AccordionForums from "../../components/AccordionForums/AccordionForums";
import AccordionContentWrapper from "../../components/AccordionContentWrapper/AccordionContentWrapper";
import './greenForums.scss'
import {Col, Container, Row, UncontrolledPopover, FormGroup, Label, Input} from 'reactstrap';
import {useTranslation} from "react-i18next";
import BrowseCategories from "../../components/BrowseCategories/BrowseCategories";
import {Link} from "react-router-dom";


const GreenForums = () => {

    const {t} = useTranslation();

    return (

        <div style={{backgroundColor: '#eaeef1'}}>
            <Header/>
                    <Link to="/lobby">
                        <div className="text-center float-left py-3 px-3 position-fixed">
                            <Button className="bMob" text={t('btnPres')} type="gradient2"/>
                        </div>
                    </Link>

            <Container>
            <div className="mt-4 aMob">
                <AccordionForums isOpenDefaultValue={false} title={t('dayOneTitle')}>
                    <AccordionContentWrapper>
                        <h6>{t('d11Text1')}</h6>
                        <h6 className="bgTextON font-weight-bold mt-4 text-light">10:30 - 11:00</h6>
                        <h6 className="small ml-4 forumsText">{t('d11Text2')}<br/>
                        <b>&#8226; Astrit Panxha</b>{t('d11Text3')}<br/>
                        <b>&#8226; Joern Rode</b>{t('d11Text4')}<br/>
                        <b>&#8226; Carin Lobbezoo</b>{t('d11Text5')}<br/>
                        <b>&#8226; Eriola Bibolli</b>{t('d11Text6')}</h6>
                    </AccordionContentWrapper>
                <AccordionContentWrapper>
                    <Link to="/webinar/dayone1105_tr">
                        <Button text={t('btnForumsJoinTrans')} type="gradient" className="float-right btnGen"/>
                    </Link>
                    <Link to="/webinar/dayone1105">
                        <Button text={t('btnForumsJoin')} type="gradient" className="float-right btnGen btnEN"/>
                    </Link>

                    <h6><b>{t('d12Title1')}</b> </h6>
                    <h6 className="bgTextON font-weight-bold mt-4 text-light">11:05 - 12:00</h6>
                    <h6 className="mt-3 bold">{t('d11Title2')}</h6>
                    <h6 className="small ml-4 mb-4 forumsText"><b>&#8226; Albena Reshitaj</b> {t('d11Text7')}</h6>
                    <h6>{t('d12Title2')}</h6>
                    <h6 className="small ml-4 forumsText">Moderator: <b>Avni Sfishta</b>{t('d12Text1')}<br/></h6>

                    <h6 className="small ml-4 forumsText">
                        {t('d12PanelText1')} <br/>
                        <b>&#8226; Servet Spahiu</b>{t('d12Text2')}<br/>
                        <b>&#8226; Fatos Hasani</b>{t('d12Text3')}<br/>
                        <b>&#8226; Besim Islami</b>{t('d12Text4')}<br/>
                        <b>&#8226; Rhedon Begolli</b>{t('d12Text5')}<br/>
                        <b>&#8226; Lumnije Gashi</b>{t('d12Text6')}<br/>
                    </h6>
                    <h6 className="mt-3 bold">{t('d12Title3')}</h6>
                    <h6 className="small ml-4 forumsText">{t('d12TextQuest')}</h6>
                </AccordionContentWrapper>
                <AccordionContentWrapper>
                    <Link to="/webinar/dayone1500_tr">
                        <Button text={t('btnForumsJoinTrans')} type="gradient" className="float-right btnGen"/>
                    </Link>
                    <Link to="/webinar/dayone1500">
                        <Button text={t('btnForumsJoin')} type="gradient" className="float-right btnGen btnEN"/>
                    </Link>
                    <h6><b>{t('d13Title1')}</b>{t('d13Title2')}</h6>
                    <h6 className="bgTextON font-weight-bold mt-4 text-light">15:00 - 16:30</h6>
                    <h6 className="small ml-4 forumsText">Moderator: <b>Gëzime Hasani</b> {t('d13Text1')}<br/></h6>

                    <h6 className="small ml-4 forumsText">
                        {t('d12PanelText1')}<br/>
                        <b>&#8226; Faton Hoxha</b> {t('d13Text2')}<br/>
                        <b>&#8226; Shend Boshnjaku</b> {t('d13Text3')}<br/>
                        <b>&#8226; Enes Krasniqi</b> {t('d13Text4')}<br/>
                        <b>&#8226; Muhamet Malsiu</b> {t('d22Text2')}<br/>
                        <b>&#8226; Maarten A. Siebel</b> {t('d13Text5')}<br/>
                        <b>&#8226; Martin Alite</b> {t('d13Text6')}<br/>
                    </h6>
                    <h6 className="mt-3 bold">{t('d12Title3')}</h6>

                    <h6 className="small ml-4 forumsText">{t('d12TextQuest')}</h6>

                </AccordionContentWrapper>
                </AccordionForums>
                <AccordionForums isOpenDefaultValue={true} title={t('dayTwoTitle')}>
                    <AccordionContentWrapper>
                        <Link to="/webinar/daytwo1015_tr">
                            <Button text={t('btnForumsJoinTrans')} type="gradient" className="float-right btnGen"/>
                        </Link>
                        <Link to="/webinar/daytwo1015">
                            <Button text={t('btnForumsJoin')} type="gradient" className="float-right btnGen btnEN"/>
                        </Link>
                        <h6><b>{t('d21Title1')}</b></h6>
                        <h6 className="bgTextON font-weight-bold mt-4 text-light">10:15 - 10:20</h6>
                        <h6 className="small ml-4 forumsText"><b>&#8226; {t('d21Text1')}</b></h6>
                        <h6 className="small ml-4 forumsText">{t('d21Text2')}</h6>
                    </AccordionContentWrapper>
                    <AccordionContentWrapper>
                        <Link to="/webinar/daytwo1030_tr">
                            <Button text={t('btnForumsJoinTrans')} type="gradient" className="float-right"/>
                        </Link>
                        <Link to="/webinar/daytwo1030">
                            <Button text={t('btnForumsJoin')} type="gradient" className="float-right btnEN"/>
                        </Link>
                        <h6><b>{t('d22Title1')}</b></h6>
                        <h6 className="bgTextON font-weight-bold mt-4 text-light">10:30 - 11:30</h6>
                        <h6 className="small ml-4 forumsText">Moderator: <b>Vllaznim Osmani</b> {t('d22Text1')}</h6>
                        <h6 className="small ml-4 forumsText">
                            {t('d12PanelText1')}<br/>
                            <b>&#8226; Muhamet Malsiu</b> {t('d22Text2')}<br/>
                            <b>&#8226; Osman Bytyqi</b> {t('d22Text3')}<br/>
                            <b>&#8226; Sejdi Halimi</b> {t('d22Text4')}<br/>
                            <b>&#8226; Rina Fetahaj</b> {t('d22Text5')}<br/>
                        </h6>
                        <h6 className="mt-3 bold">{t('d12Title3')}</h6>
                        <h6 className="small ml-4 forumsText">{t('d12TextQuest')}</h6>
                    </AccordionContentWrapper>
                    <AccordionContentWrapper>
                        <a href="https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_Njc3ZTdjZDUtM2IwOC00NTRhLWFhNzctNWNkNTZlYWJhN2Vh%40thread.v2%2F0%3Fcontext%3D%257b%2522Tid%2522%253a%252287e6c7e5-14b8-4f81-bb11-b108a93df982%2522%252c%2522Oid%2522%253a%252253b6554b-9428-4dcd-8fd0-3a1f54366ac1%2522%257d%26anon%3Dtrue&type=meetup-join&deeplinkId=bce79748-51e0-47d6-9b2d-6ad1b264f628&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true">
                            <Button text={t('btnForumsJoinAL')} type="gradient" className="float-right"/>
                        </a>
                        <a href="https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_NDIyNzQ5NzMtODQ4MS00ZjBjLTljZjUtNWVlZmZlMmFiMGRj%40thread.v2%2F0%3Fcontext%3D%257b%2522Tid%2522%253a%252287e6c7e5-14b8-4f81-bb11-b108a93df982%2522%252c%2522Oid%2522%253a%252253b6554b-9428-4dcd-8fd0-3a1f54366ac1%2522%257d%26anon%3Dtrue&type=meetup-join&deeplinkId=d86c583c-d2f4-4ae2-b417-9ebf10c8d53d&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true">
                            <Button text={t('btnForumsJoinEN')} type="gradient" className="float-right btnEN"/>
                        </a>
                        <h6><b>{t('d23Title1')}</b></h6>
                        <h6 className="bgTextON font-weight-bold mt-4 text-light">13:15 - 14:30</h6>

                        <h6 className="small ml-4 forumsText">
                            <b>&#8226; David Jacobs</b> {t('d23Text1')}</h6>
                        <h6 className="small ml-4 forumsText">{t('d23Text2')}</h6>
                        <h6 className="mt-3 bold">{t('d12Title3')}</h6>

                        <h6 className="small ml-4 forumsText">{t('d12TextQuest')}</h6>
                    </AccordionContentWrapper>
                </AccordionForums>
            </div>
                </Container>
            <BrowseCategories/>
            <Footer/>
        </div>
    );

}
export default GreenForums;